import axios, { CancelToken, CancelTokenSource } from 'axios';

export default class AxiosCancellationToken {
	private readonly _tokenSource: CancelTokenSource;
	private _cancelled = false;

	public get token(): CancelToken {
		return this._tokenSource.token;
	}

	constructor() {
		this._tokenSource = axios.CancelToken.source();
	}

	public cancel(): void {
		this._tokenSource.cancel();
		this._cancelled = true;
	}

	public isCancellationRequested(): boolean {
		return this._cancelled;
	}
}
